// @ts-check

/**
 * @type {Record<import("./Popup").PopupEnterAnimationSimple, import("./Popup").PopupEnterAnimationObj>}
 */
const enterAnimationCatalog = {
  appear: {
    overlay: {
      delay: 0,
      duration: 0,
      easing: 'linear',
      effect: 'fade-in',
    },
    popup: {
      delay: 0,
      duration: 0,
      easing: 'linear',
      effect: 'fade-in',
    },
  },
  'fade-in': {
    overlay: {
      delay: 0,
      duration: 200,
      easing: 'linear',
      effect: 'fade-in',
    },
    popup: {
      delay: 300,
      duration: 200,
      easing: 'linear',
      effect: 'fade-in',
    },
  },
  'slide-in-top': {
    overlay: {
      delay: 0,
      duration: 200,
      easing: 'linear',
      effect: 'fade-in',
    },
    popup: {
      delay: 100,
      duration: 200,
      easing: 'ease-in',
      effect: 'slide-in-top',
    },
  },
  'slide-in-bottom': {
    overlay: {
      delay: 0,
      duration: 200,
      easing: 'linear',
      effect: 'fade-in',
    },
    popup: {
      delay: 100,
      duration: 200,
      easing: 'ease-in',
      effect: 'slide-in-bottom',
    },
  },
  'slide-in-left': {
    overlay: {
      delay: 0,
      duration: 200,
      easing: 'linear',
      effect: 'fade-in',
    },
    popup: {
      delay: 100,
      duration: 200,
      easing: 'ease-in',
      effect: 'slide-in-left',
    },
  },
  'slide-in-right': {
    overlay: {
      delay: 0,
      duration: 200,
      easing: 'linear',
      effect: 'fade-in',
    },
    popup: {
      delay: 100,
      duration: 200,
      easing: 'ease-in',
      effect: 'slide-in-right',
    },
  },
  'ease-in-top': {
    overlay: {
      delay: 0,
      duration: 200,
      easing: 'linear',
      effect: 'fade-in',
    },
    popup: {
      delay: 100,
      duration: 200,
      easing: 'ease-in',
      effect: 'ease-in-top',
    },
  },
  'ease-in-bottom': {
    overlay: {
      delay: 0,
      duration: 200,
      easing: 'linear',
      effect: 'fade-in',
    },
    popup: {
      delay: 100,
      duration: 200,
      easing: 'ease-in',
      effect: 'ease-in-bottom',
    },
  },
  'ease-in-left': {
    overlay: {
      delay: 0,
      duration: 200,
      easing: 'linear',
      effect: 'fade-in',
    },
    popup: {
      delay: 100,
      duration: 200,
      easing: 'ease-in',
      effect: 'ease-in-left',
    },
  },
  'ease-in-right': {
    overlay: {
      delay: 0,
      duration: 200,
      easing: 'linear',
      effect: 'fade-in',
    },
    popup: {
      delay: 100,
      duration: 200,
      easing: 'ease-in',
      effect: 'ease-in-right',
    },
  },
}

/**
 * @type {Record<import("./Popup").PopupExitAnimationSimple, import("./Popup").PopupExitAnimationObj>}}
 */
const exitAnimationCatalog = {
  disappear: {
    overlay: {
      delay: 0,
      duration: 0,
      easing: 'linear',
      effect: 'fade-out',
    },
    popup: {
      delay: 0,
      duration: 0,
      easing: 'linear',
      effect: 'fade-out',
    },
  },
  'fade-out': {
    overlay: {
      delay: 0,
      duration: 200,
      easing: 'linear',
      effect: 'fade-out',
    },
    popup: {
      delay: 300,
      duration: 200,
      easing: 'linear',
      effect: 'fade-out',
    },
  },
  'slide-out-top': {
    overlay: {
      delay: 100,
      duration: 200,
      easing: 'linear',
      effect: 'fade-out',
    },
    popup: {
      delay: 0,
      duration: 200,
      easing: 'ease-out',
      effect: 'slide-out-top',
    },
  },
  'slide-out-bottom': {
    overlay: {
      delay: 100,
      duration: 200,
      easing: 'linear',
      effect: 'fade-out',
    },
    popup: {
      delay: 0,
      duration: 200,
      easing: 'ease-out',
      effect: 'slide-out-bottom',
    },
  },
  'slide-out-left': {
    overlay: {
      delay: 100,
      duration: 200,
      easing: 'linear',
      effect: 'fade-out',
    },
    popup: {
      delay: 0,
      duration: 200,
      easing: 'ease-out',
      effect: 'slide-out-left',
    },
  },
  'slide-out-right': {
    overlay: {
      delay: 100,
      duration: 200,
      easing: 'linear',
      effect: 'fade-out',
    },
    popup: {
      delay: 0,
      duration: 200,
      easing: 'ease-out',
      effect: 'slide-out-right',
    },
  },
  'ease-out-top': {
    overlay: {
      delay: 0,
      duration: 200,
      easing: 'linear',
      effect: 'fade-out',
    },
    popup: {
      delay: 0,
      duration: 200,
      easing: 'ease-out',
      effect: 'ease-out-top',
    },
  },
  'ease-out-bottom': {
    overlay: {
      delay: 200,
      duration: 200,
      easing: 'linear',
      effect: 'fade-out',
    },
    popup: {
      delay: 0,
      duration: 200,
      easing: 'ease-out',
      effect: 'ease-out-bottom',
    },
  },
  'ease-out-left': {
    overlay: {
      delay: 200,
      duration: 200,
      easing: 'linear',
      effect: 'fade-out',
    },
    popup: {
      delay: 0,
      duration: 200,
      easing: 'ease-out',
      effect: 'ease-out-left',
    },
  },
  'ease-out-right': {
    overlay: {
      delay: 200,
      duration: 200,
      easing: 'linear',
      effect: 'fade-out',
    },
    popup: {
      delay: 0,
      duration: 200,
      easing: 'ease-out',
      effect: 'ease-out-right',
    },
  },
}

export { enterAnimationCatalog, exitAnimationCatalog }
